module.exports = __webpack_public_path__ + "static/img/300.18336423.png";